import React from 'react'

import { Button, Link, Text, TwistIcons, TwistLogo } from '@doist/marketist'

import cn from 'classnames'
import { Interpolate } from 'components'
import { ContainerSidebar } from 'components/container-sidebar/container-sidebar'
import { useTranslation } from 'next-i18next'

import Slack from './slack.svg'

import css from './slack-lacks.module.css'

export function SlackLacks() {
    const { t } = useTranslation('pricing')

    return (
        <ContainerSidebar tag="section" className={css.slackLacksContainer}>
            <ContainerSidebar.Aside tag="header">
                <Text tag="h2" className={css.slackLacksTitle} size="major-xl">
                    {t('slackLacks')}
                </Text>
                <Button
                    className={css.slackLacksCTA}
                    href="/slack-alternative"
                    variant="tertiary"
                    endIcon="ChevronRight"
                >
                    {t('learnMore')}
                </Button>
            </ContainerSidebar.Aside>
            <ContainerSidebar.Main className={css.mainContainer}>
                <div>
                    <div className={css.compareLogo}>
                        <Slack width={100} height={25} />
                    </div>
                    <ul className={css.list}>
                        <ListItem>{t('informationBuried')}</ListItem>
                        <ListItem>{t('respondASAP')}</ListItem>
                        <ListItem>{t('siloedConversations')}</ListItem>
                        <ListItem>{t('oneLine')}</ListItem>
                        <ListItem>{t('shallowWork')}</ListItem>
                        <ListItem>{t('shareholders')}</ListItem>
                        <ListItem>{t('inequities')}</ListItem>
                    </ul>
                </div>
                <div>
                    <div className={css.compareLogo}>
                        <TwistLogo width={98} height={32} />
                    </div>
                    <ul className={cn(css.list, css.twistList)}>
                        <ListItem variant="tick">{t('onTopic')}</ListItem>
                        <ListItem variant="tick">{t('respondCalmly')}</ListItem>
                        <ListItem variant="tick">{t('easilyAccessible')}</ListItem>
                        <ListItem variant="tick">{t('thoughtful')}</ListItem>
                        <ListItem variant="tick">
                            <Interpolate
                                t={t}
                                i18nKey="deepWork"
                                mapping={{ link: <Link size="body-xs" href="/async" /> }}
                            />
                        </ListItem>
                        <ListItem variant="tick">{t('bootstrapped')}</ListItem>
                        <ListItem variant="tick">{t('parity')}</ListItem>
                    </ul>
                </div>
            </ContainerSidebar.Main>
        </ContainerSidebar>
    )
}

function ListItem({
    children,
    variant = 'cross',
}: {
    children: React.ReactNode
    variant?: 'tick' | 'cross'
}) {
    const Icon = variant === 'cross' ? TwistIcons.X : TwistIcons.Check

    return (
        <Text tag="li" size="body-xs" className={css.listItem}>
            <Icon width={14} height={14} className={css.listItemIcon} />
            <span>{children}</span>
        </Text>
    )
}
